export const actions = {
    GET_ACTIVITY_REPORT: 'GET_ACTIVITY_REPORT',
    GET_EXAM_POPULATE_PURGE: 'GET_EXAM_POPULATE_PURGE',
    GET_QUESTION_BANK_EXCEL_DOWNLOAD : 'GET_QUESTION_BANK_EXCEL_DOWNLOAD',
    GET_DOWNLOAD_STUDENT_LIST_REPORT : 'GET_DOWNLOAD_STUDENT_LIST_REPORT',
    DOWNLOAD_ATTENDANCE: "DOWNLOAD_ATTENDANCE",
    UPLOAD_MULTI_QUESTIONS_EXCEL: "UPLOAD_MULTI_QUESTIONS_EXCEL",
    SAVE_UPLOADED_QUESTIONS: "SAVE_UPLOADED_QUESTIONS",
    SEND_TWO_FACTOR_VERIFICATION_MAIL: "SEND_TWO_FACTOR_VERIFICATION_MAIL",
    MESSAGE_TO_INCOMPLETERS: "MESSAGE_TO_INCOMPLETERS"
};